export type ObjectLiteral<T = any> = { [key: string]: T };

// Taken from the api
export enum DeskAvailabilityStatus {
    AVAILABLE = "available", // desk is available for booking based on date + time params
    PARTIAL = "partial", // desk is partially available for booking based on date + time params
    UNAVAILABLE = "unavailable", // desk is not available for booking, because you don't have permissions
    OCCUPIED = "occupied", // desk is not available, because it is occupied (booked by someone, or yourself)
    INACTIVE = "inactive", // desk is inactive, which means it has x + y coords on the floormap, but is soft deleted
    DELETED = "deleted", // desk is deleted, which means it has NO x + y coords on the floormap, and is soft deleted
    UNKNOWN = "unknown",
    SELECTED = "selected", // not from the api, but we use it
}
